import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', 
    },
    fallbackLng: 'en', 
    debug: false,
    lng: 'en',
    interpolation: {
      escapeValue: false, 
    },
    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'cookie'],
    },
    supportedLngs: ['en', 'fr','ar'], 
    load: 'languageOnly',
  });

export default i18n;